import React, { lazy, Suspense } from "react";
import Icon from "@mui/material/Icon";
import { Box, CircularProgress } from "@mui/material";
const Dashboard = lazy(() => import("layouts/dashboard"));
const Tables = lazy(() => import("layouts/tables"));

const Calendar = lazy(() => import("layouts/calendar"));

const Profile = lazy(() => import("layouts/profile"));
const SignUp = lazy(() => import("layouts/authentication/sign-up"));
const unauthorized = React.lazy(()=> import("layouts/authentication/Unauthorized"));
const Status = lazy(()=> import ("layouts/settings"));
const Reports = lazy(()=> import ("layouts/reports"));
const Kanban = lazy(()=> import ("layouts/kanban"));
const homePage = React.lazy(() => import("layouts/Homepage"));
import { useAuth } from "layouts/authentication/AuthContext";
import ProtectedRoute from "layouts/authentication/ProtectedRoute";
import { Mail } from "@mui/icons-material";
import { useCurrency } from "context/CurrencyContext";
const routes = () => {
  const { userRole, permissions } = useAuth();
//  const {symbol} = useCurrency();
  return [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "collapse",
      name: "Leads",
      key: "leads",
      icon: <Icon fontSize="small">contacts</Icon>,
      route: "/leads",
      component: (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Tables />
        </Suspense>
      ),
    },
    
    {
      type: "collapse",
      name: "Calendar",
      key: "calendar",
      icon: <Icon fontSize="small">calendar_month</Icon>,
      route: "/calendar",
      component: (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Calendar />
        </Suspense>
      ),
    },
    {
      type: "collapse",
      name: "Kanban",
      key: "kanban",
      icon: <Icon fontSize="small">view_kanban</Icon>,
      route: "/kanban",
      component: (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            >
              <CircularProgress />
            </Box>
          }
        >
          < Kanban />
        </Suspense>
      ),
    },
    {
      type: "collapse",
      name: "Profile",
      key: "profile",
      icon: <Icon fontSize="small">person</Icon>,
      route: "/profile",
      component: (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Profile />
        </Suspense>
      ),
    },
   
    userRole === "admin" && {
      type: "collapse",
      name: "Reports",
      key: "reports",
      icon: <Icon fontSize="small">summarize</Icon>,
      route: "reports",
      component: (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Reports />
        </Suspense>
      ),
    },
     (userRole === "admin" || permissions?.can_edit_products) &&  {
      type: "collapse",
      name: "Settings",
      key: "settings",
      icon: <Icon fontSize="small">settings</Icon>,
      route: "settings",
      component: (
        <Suspense
          fallback={
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="100vh"
            >
              <CircularProgress />
            </Box>
          }
        >
          <Status />
        </Suspense>
      ),
    },
    
  ].filter(Boolean); 
};

export default routes;
